const UUID_MASK = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';

export function generateUUID() {
    let d = new Date().getTime();
    return UUID_MASK.replace(/[xy]/g, function(char) {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (char === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
}
